import { LICENSE_MODULES, ROLES } from '../../../../../constants';

import Tickets from '../../v2/components/tickets/tickets';
import TicketDetails from '../../v2/components/tickets/tickets/ticket';

import FieldDetails from '../../v2/components/form-template/upsert-templates/common/field-details';
import TicketsTemplates from '../../v2/components/form-template/templates-list/ticket-templates';

import NewTicketTemplate from '../../v2/components/form-template/upsert-templates/ticket/new-template';
import EditTicketTemplate from '../../v2/components/form-template/upsert-templates/ticket/edit-template';
import CopyTicketTemplate from '../../v2/components/form-template/upsert-templates/ticket/copy-template';

export default [
  {
    path: '/',
    name: 'home',
    redirect: '/dashboard',
    meta: {
      title: '',
      requiresAuth: true,
      module: LICENSE_MODULES.TICKETS,
      roles: '*',
    },
  },
  {
    path: '/tickets/templates',
    name: 'templates',
    component: TicketsTemplates,
    meta: {
      title: 'ticket_templates',
      requiresAuth: true,
      modules: LICENSE_MODULES.TICKETS,
      roles: '*',
    },
  },
  {
    path: '/tickets/new-template/:id/field-details',
    name: 'field-details',
    component: FieldDetails,
    meta: {
      title: 'ticket_field_details',
      requiresAuth: true,
      modules: LICENSE_MODULES.TICKETS,
      roles: '*',
    },
  },

  {
    path: '/tickets/new-template/:id',
    name: 'new-template',
    component: NewTicketTemplate,
    meta: {
      title: 'new_ticket_templates',
      requiresAuth: true,
      modules: LICENSE_MODULES.TICKETS,
      roles: '*',
    },
  },
  {
    path: '/tickets/templates/:id/edit',
    name: 'edit-ticket-template',
    component: EditTicketTemplate,
    meta: {
      title: 'edit_ticket_templates',
      requiresAuth: true,
      modules: LICENSE_MODULES.TICKETS,
      roles: '*',
    },
  },
  {
    path: '/tickets/copy-template/:id',
    name: 'copy-template',
    component: CopyTicketTemplate,
    meta: {
      title: 'new_ticket_templates',
      requiresAuth: true,
      modules: LICENSE_MODULES.TICKETS,
      roles: '*',
    },
  },
  {
    path: '/tickets/tickets',
    name: 'tickets',
    component: Tickets,
    meta: {
      title: 'tickets',
      requiresAuth: true,
      roles: '*',
      modules: LICENSE_MODULES.TICKETS,
    },
  },
  {
    path: '/tickets/new-ticket',
    name: 'new-ticket',
    component: TicketDetails,
    meta: {
      title: 'create_new_ticket',
      requiresAuth: true,
      roles: '*',
      modules: LICENSE_MODULES.TICKETS,
      isGoBackBtn: true,
    },
  },
  {
    path: '/tickets/ticket/:id',
    name: 'ticket-details',
    component: TicketDetails,
    meta: {
      title: 'ticket_details',
      requiresAuth: true,
      roles: '*',
      modules: LICENSE_MODULES.TICKETS,
    },
  },
];
